<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ enterprise ? enterprise.Name : '' }}</h1>
    <br>
    <v-toolbar :color="enterpriseColor" dark>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('enterprises.enterpriseTitle') }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <form-enterprise
      :data="enterprise"
      :onDelete="handleDelete"
      :onSave="handleSave"
      :onCancel="handleCancel"
      :onClearStats="handleClearStats"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import FormEnterprise from './FormEnterprise'
  export default {
    components: {
      FormEnterprise
    },
    data: () => ({
      enterprise: {},
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      userID () {
        return this.$route.params.id
      },
    },
    watch:{
      $route (to, from){
        if (to.params.id && to.params.id !== from.params.id) {
          if (to.params.id.length > 0) {
            this.handleGetUser()
          }
        }
      }
    },
    mounted () {
      this.handleGetEnterprise()
    },
    methods: {
      handleGetEnterprise () {
        if (this.userID !== 'new') {
          api.getItem('enterprises', true, this.userID).then(response => {
            this.enterprise = {
              Name: response.Name
            }
          })
        } else {
          this.enterprise = null
        }
      },
      handleClearStats () {
        api.deleteItem('stats', this.userID).then(response => {
          if (response.status === 200) this.$router.push('/enterprises')
        })
      },
      handleDelete () {
        api.deleteItem('enterprises', this.userID).then(response => {
          if (response.status === 200) this.$router.push('/enterprises')
        })
      },
      handleCancel () {
        this.$router.push('/enterprises')
      },
      handleSave (body) {
        if (this.userID === 'new') {
          api.addItem('enterprises', true, body)
            // .then(response => {
            //   console.log(response)
            // })
            // .catch(error => {
            //   console.log('error', error)
            // })
        } else {
          api.updateItem('enterprises', this.userID, body)
            // .then(response => {
            //   console.log(response)
            // })
            // .catch(error => {
            //   console.log('error', error)
            // })
        }
        this.$router.push('/enterprises')
      }
    }
  }
</script>
